import { mapMutations, mapState } from 'vuex';
import { randomInt } from '../../../utils/vuex';
import GeoDataMixin from './geoDataMixin';
export default {
  name: 'CoreDtwinGeoDetails',
  mixins: [GeoDataMixin],
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    twinImages: {
      type: Array,
      required: true
    },
    twinCanBeEdited: {
      type: Boolean,
      required: true
    },
    hasFloorTwinReadPermissions: {
      type: Boolean,
      required: true
    },
    floorTwinOverlayData: {
      type: Object,
      required: false,
      default: () => ({})
    },
    hideFields: {
      // 'polygon', 'mapicon', 'floor', 'floorplan'
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {
      fullScreenMap: false,
      overlayDialog: false,
      overlayInfo: null,
      overlayUploadItem: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'UiTheme']),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    }
  },
  watch: {},
  methods: {
    ...mapMutations('app', ['snackbar']),
    overlayImageSelected() {
      if (!this.twinObject.data.indoor.neLat && !this.twinObject.data.indoor.swLat) {
        this.twinObject.data.indoor.neLat = this.twinObject.coordinates.coordinates[1] + 0.0001;
        this.twinObject.data.indoor.neLon = this.twinObject.coordinates.coordinates[0] + 0.0001;
        this.twinObject.data.indoor.swLat = this.twinObject.coordinates.coordinates[1] - 0.0001;
        this.twinObject.data.indoor.swLon = this.twinObject.coordinates.coordinates[0] - 0.0001;
      }
    },
    overlayImageUploaded(attachment) {
      this.overlayDialog = false;
      const attachmentItem = {
        id: attachment.fileId,
        name: attachment.item.name,
        size: attachment.item.size
      };
      this.twinObject.data.attachments = (this.twinObject.data.attachments || []).concat([attachmentItem]);
      this.twinObject.data.indoor.overlayImageId = attachmentItem.id;
      this.twinObject.data.indoor.neLat = this.overlayInfo.ne.lat;
      this.twinObject.data.indoor.neLon = this.overlayInfo.ne.lon;
      this.twinObject.data.indoor.swLat = this.overlayInfo.sw.lat;
      this.twinObject.data.indoor.swLon = this.overlayInfo.sw.lon;
    },
    handleOverlayImage(processedInfo) {
      this.overlayInfo = processedInfo;
      const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
          type: mime
        });
      };
      const attachmentItem = dataURLtoFile(processedInfo.image, processedInfo.imageFileName);
      this.overlayUploadItem = {
        id: `${Date.now()}${randomInt(2000)}`,
        name: attachmentItem.name,
        size: attachmentItem.size,
        file: attachmentItem
      };
    }
  }
};